const WHATSAPP_PHONE_NUMBERS: Record<number, string> = {
	8: '5551995119738',
	9: '5541991093951',
	10: '5531971111522',
	1: '5585981708231',
	14: '5511942136780',
};

const WHATSAPP_PHONE_NOTRE_DAME = '558008500087';

export function generateWhatsAppUrl(cdEmpresaPlano: number, isNotredame?: boolean): string {
	const phoneNumber = isNotredame
		? WHATSAPP_PHONE_NOTRE_DAME
		: WHATSAPP_PHONE_NUMBERS[cdEmpresaPlano];

	return `https://api.whatsapp.com/send/?phone=${phoneNumber}&text&type=phone_number&app_absent=0`;
}
